export const PLACEHOLDER_ADS_TEXT = "Загрузка рекламы...";

export const AD_BLOCK_1_ID = "R-A-9656846-3";
export const AD_BLOCK_2_ID = "R-A-9656846-4";
export const AD_BLOCK_3_ID = "R-A-9656846-5";
export const AD_BLOCK_4_ID = "R-A-9656846-6";
export const AD_BLOCK_5_ID = "R-A-9656846-7";

export const AD_BLOCK_6_OWNER_ID = "10879177";
export const AD_BLOCK_6_ID = "175396769039221317";